<template>
    <div>
        <base-header class="pb-1">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">Regra</h6>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--6">
            <card>
                <h2 slot="header" class="mb-0">Regra</h2>
                <h5 slot="header" class="mb-0">Descrição das regras e regulamento do nosso Bolão</h5>
                <div class="row">
                    <div class="col-12">

                        &nbsp;&nbsp; 1ª) O <strong>Bolão 10 Copa</strong> é o bolão de apostas para a <strong>Copa do Mundo de 2026</strong>. É composto dos jogos pertencentes à Copa do Mundo de Futebol de 2026, a ser realizada no Canadá, Estados Unidos e México, a partir do dia <strong>11 de junho</strong>, num total de <strong>104 (cento e quatro) jogos</strong>, distribuídos nas fases:<br/>
                        <br/>
                        &nbsp;&nbsp; &nbsp;&nbsp; 1ª: Fase de Grupos - 48 países com 72 jogos.<br/>
                        <br/>
                        &nbsp;&nbsp; &nbsp;&nbsp; 2ª: Segunda fase ou 16 Avos - 32 países com 16 jogos.<br/>
                        <br/>
                        &nbsp;&nbsp; &nbsp;&nbsp; 3ª: Oitavas de Final - 16 países com 8 jogos.<br/>
                        <br/>
                        &nbsp;&nbsp; &nbsp;&nbsp; 4ª: Quartas de Final - 8 países com 4 jogos.<br/>
                        <br/>
                        &nbsp;&nbsp; &nbsp;&nbsp; 5ª: Semi Final - 4 países com 2 jogos.<br/>
                        <br/>
                        &nbsp;&nbsp; &nbsp;&nbsp; 6ª: Disputa do 3º e 4º lugares - 2 países com 1 jogo.<br/>
                        <br/>
                        &nbsp;&nbsp; &nbsp;&nbsp; 7ª: Disputa da Final - 2 países com 1 jogo.<br/>
                        <br/>
                        &nbsp;&nbsp; &nbsp;&nbsp; 8ª: Artilharia: País de origem do jogador artilheiro da copa do mundo.<br/>
                        <br/>
                        &nbsp;&nbsp; 2ª) O valor de cada aposta é de <strong>R$ 100,00 (cem reais)</strong> para o Bolão completo (todas as fases), cuja data <strong>limite para as apostas e pagamento do bolão é <span class="text-danger">05/06/2026 às 23h59</span></strong>. Aquele apostador que não concluir a aposta até o final do prazo e/ou não efetivar o depósito até a data citada estará <U><strong>automaticamente excluído do Bolão 10</strong></U>.<br/>
                        <br/>
                        &nbsp;&nbsp; 3ª) Os passos para ser incluído como usuário apostador do Bolão 10 são os seguintes:<br/>
                        <br/>
                        &nbsp;&nbsp; &nbsp;&nbsp; a) solicitar "login" (e-mail do usuário) e "senha provisória" para cadastramento do usuário como apostador. O pedido poderá ser efetuado por Whatsapp (61) 9 9217-1968 - Marcos Osorio ou (61) 9 8111-6330 Oswaldo Osorio<br/>
                        <br/>
                        &nbsp;&nbsp; &nbsp;&nbsp; b) o administrador do Bolão 10 fornecerá o "login" (e-mail) e a "senha provisória" para o apostador;<br/>
                        <br/>
                        &nbsp;&nbsp; &nbsp;&nbsp; c) de posse do "login" e da "senha provisória" o apostador poderá fazer as apostas no site www.bolao10.top;<br/>
                        <br/>
                        &nbsp;&nbsp; &nbsp;&nbsp; d) ao fazer o primeiro acesso no "login" será necessário alterar a "senha provisória" para sua "senha definitiva" a escolha do usuário, necessitando ter 8 caracteres.<br/>
                        <br/>
                        &nbsp;&nbsp; 4ª) A importância da aposta, no valor de R$ 100,00 (cem reais), será efetuada em uma única parcela via PIX. Após a transferência, deverá ser enviado o comprovante de pagamento pelo Whatsapp (61) 9 9217-1968 (Marcos Osorio) ou  (61) 9 8111-6330 Oswaldo Osorio para darmos como pago no sistema.<br/>
                        &nbsp;&nbsp; <strong>Valor: R$ 100,00</strong><br/>
                        &nbsp;&nbsp; <strong>Banco do Brasil</strong><br/>
                        &nbsp;&nbsp; <strong>Chave PIX: 723.700.411-53</strong><br/>
                        &nbsp;&nbsp; <strong>Nome: Marcos Coimbra Osorio</strong><br/>
                        <br/>
                        &nbsp;&nbsp; 5ª) É obrigatória para a participação que a aposta esteja de forma COMPLETA, isto é, com todos os palpites relativos a todas as fases, inclusive as colocações das seleções e artilharia. O sistema não permite a conclusão das apostas se houver algum palpite sobrando. Mas o usuário pode salvar sua aposta a qualquer momento para que a finalize posteriormente.<br/>
                        <br/>
                        &nbsp;&nbsp; 6ª) A contagem de pontos será efetuada utilizando-se a seguinte tabela:<br/>
                        <br/>
                        <TABLE cellpadding="4">
                        <TR><TD>
                        &nbsp;&nbsp; &nbsp;&nbsp; Palpite exato da partida: </TD><TD> <strong>5 pontos</strong> </TD><TD> Ex.: Placar 3x2. Palpite 3x2. </TD></TR>
                        <TR><TD>
                        &nbsp;&nbsp; &nbsp;&nbsp; Palpite certo do time vencedor: </TD><TD> <strong>3 pontos</strong> </TD><TD> Ex.: Placar 3x2. Palpite 3x0. </TD></TR>
                        <TR><TD>
                        &nbsp;&nbsp; &nbsp;&nbsp; Palpite certo do time perdedor: </TD><TD> <strong>2 pontos</strong> </TD><TD> Ex.: Placar 3x2. Palpite 4x2. </TD></TR>
                        <TR><TD>
                        &nbsp;&nbsp; &nbsp;&nbsp; Palpite de empate certo, mas placar errado: </TD><TD> <strong>3 pontos</strong> </TD><TD> Ex.: Placar 2x2. Palpite 1x1. </TD></TR>
                        <TR><TD>
                        &nbsp;&nbsp; &nbsp;&nbsp; Vencedor/Perdedor certo, mas placar errado: </TD><TD> <strong>1 ponto</strong> </TD><TD> Ex.: Placar 3x2. Palpite 1x0. </TD></TR>
                        <TR><TD>
                        &nbsp;&nbsp; &nbsp;&nbsp; Artilheiro (país de origem): </TD><TD> <strong>10 pontos</strong> </TD><TD> </TD></TR>
                        <TR><TD>
                        &nbsp;&nbsp; &nbsp;&nbsp; Palpite certo para o "Campeão": </TD><TD> <strong>15 pontos</strong> </TD><TD> </TD></TR>
                        <TR><TD>
                        &nbsp;&nbsp; &nbsp;&nbsp; Palpite certo para o "Vice-Campeão": </TD><TD> <strong>12 pontos</strong> </TD><TD> </TD></TR>
                        <TR><TD>
                        &nbsp;&nbsp; &nbsp;&nbsp; Palpite certo para o "3º lugar": </TD><TD> <strong>10 pontos</strong> </TD><TD> </TD></TR>
                        <TR><TD>
                        &nbsp;&nbsp; &nbsp;&nbsp; Palpite certo para o "4º lugar": </TD><TD> <strong>8 pontos</strong> </TD><TD> </TD></TR>
                        <TR><TD>
                        &nbsp;&nbsp; &nbsp;&nbsp; Cada inversão nas colocações: </TD><TD> <strong>5 pontos</strong> </TD><TD> </TD></TR>
                        </TABLE><br/>
                        <br/>
                        &nbsp;&nbsp; 7ª) A contagem dos pontos em uma partida não será de forma acumulativa, ou seja, se o apostador acertar o placar certo da partida somente se computa 5 pontos.<br/>
                        <br/>
                        &nbsp;&nbsp; 8ª) A partir da 2ª fase da Copa do Mundo vale o resultado <U>geral da partida</U>, isto é, computando inclusive o tempo na prorrogação (90 minutos + 30 minutos), se houver. <strong>Não será computado o placar da disputa de penalidades</strong>, quando houver.<br/>
                        <br/>
                        &nbsp;&nbsp; 9ª) Também, a partir da 2ª fase (após a classificatória) concorrem com os resultados estipulados no Bolão 10, independentemente dos países aos quais os apostadores tenham (imaginados/apostados). Em outras palavras, vale o placar apostado e não o país "imaginado".<br/>
                        <br/>
                        &nbsp;&nbsp; 10ª) O valor total do prêmio será equivalente ao total arrecadado, qual seja, o valor da aposta (R$ 100,00) multiplicado pelo número de participantes (apostadores), apenas deduzido a importância equivalente a 5% (cinco por cento) para as despesas administrativas (hospedagem, sistema e gastos diversos).<br/>
                        <br/>
                        &nbsp;&nbsp; 11ª) O valor total do prêmio será concedido aos participantes com maior número de pontos ao final do Bolão 10 (após todas as 7 fases concluídas, colocações e artilharia definida), distribuído aos 6 (seis) primeiros da seguinte forma:<br/>
                        <br/>
                        <TABLE cellpadding="4">
                        <TR><TD>
                        <strong>&nbsp;&nbsp; &nbsp;&nbsp; 1º Colocado: </strong></TD><TD> 50% (cinqüenta por cento) do valor total do prêmio. </TD></TR>
                        <TR><TD>
                        <strong>&nbsp;&nbsp; &nbsp;&nbsp; 2º Colocado: </strong></TD><TD> 20% (vinte por cento) do valor total do prêmio. </TD></TR>
                        <TR><TD>
                        <strong>&nbsp;&nbsp; &nbsp;&nbsp; 3º Colocado: </strong></TD><TD> 14% (quatorze por cento) do valor total do prêmio. </TD></TR>
                        <TR><TD>
                        <strong>&nbsp;&nbsp; &nbsp;&nbsp; 4º Colocado: </strong></TD><TD> 9% (nove por cento) do valor total do prêmio. </TD></TR>
                        <TR><TD>
                        <strong>&nbsp;&nbsp; &nbsp;&nbsp; 5º Colocado: </strong></TD><TD> 5% (cinco por cento) do valor total do prêmio. </TD></TR>
                        <TR><TD>
                        <strong>&nbsp;&nbsp; &nbsp;&nbsp; 6º Colocado: </strong></TD><TD> 2% (dois por cento) do valor total do prêmio. </TD></TR>
                        </TABLE>

                        <br/>
                        &nbsp;&nbsp; 12ª) No caso de empate de pontos, ao final do Bolão 10, entre os participantes, <strong>o critério para desempate para fins de premiação será na seguinte ordem</strong><br/>
                        <br/>
                        <TABLE cellpadding="4">
                        <TR><TD>
                        &nbsp;&nbsp; &nbsp;&nbsp; 1º - Indicação do campeão da Copa do Mundo de 2026. </TD></TR>
                        <TR><TD>
                        &nbsp;&nbsp; &nbsp;&nbsp; 2º - Maior número de pontos na fase de "Colocações". </TD></TR>
                        <TR><TD>
                        &nbsp;&nbsp; &nbsp;&nbsp; 3º - Maior número de pontos na 1ª Fase (Classificatória). </TD></TR>
                        <TR><TD>
                        &nbsp;&nbsp; &nbsp;&nbsp; 4º - Maior número de pontos nos jogos do Brasil na 1º Fase (Classificatória). </TD></TR>
                        <TR><TD>
                        &nbsp;&nbsp; &nbsp;&nbsp; 5º - Menor data e hora de pagamento da inscrição do Bolão 10. </TD></TR>
                        </TABLE>
                        <br/>
                        &nbsp;&nbsp; 13ª) Qualquer dúvida deverá ser dirimida com o administrador do Bolão 10:<br/>
                        <br/>
                        Marcos Osorio ou Oswaldo Osorio<br/>
                        Telefone: (61) 9 9217-1968 ou (61) 9 8111-6330 respectivamente<br/>
                        <br/>
                        <a name=pagamento></a>
                        Para <strong>fazer pagamento</strong> e, assim, participar do nosso bolão, basta fazer o PIX para a chave:<br/>
                        <strong>PIX: 72370041153 (CPF - Marcos Coimbra Osorio)</strong><br/>
                        Valor da aposta: R$ 100,00 (cem reais)<br/>
                        <br/>
                        <br/>
                        Enviar o comprovante para os organizadores do bolão. Boa sorte!!!<br/>

                    </div>
                </div>
            </card>
        </div> <!--- fecha conteudo -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            user:{
                password : null
            }
        };
    },
    methods:{
        changePasswd(){
            this.$clubApi.post('/user/update/passwd',{
                passwd : this.user.password
            })
            .then((response) => {
                this.$notify({type: 'success', message: "Atualização realizada"})
            }) .catch((error) => {
                this.$notify({type: 'warning', message: error.response.data.msg})
            }).finally(() =>{
                NProgress.done() 
            })
        }
    }
}
</script>

<style>

</style>
